import React from 'react';

import { CategoryExtensionProps } from '~src/category/category-manager';

import { useCategoryState } from '../category/category-state';
import { LogoDeck } from '../commons/components/logo-deck-row';

export const LogoExtension: React.FC<CategoryExtensionProps> = ({ selectedOption }) => {
  const category = useCategoryState();

  if (!category.flags.show_carrier_logos) {
    return null;
  }

  const carrierLogos = category.options.map(option => {
    /*
     * Warning: Some merchants have a setup to translate a shipping_method to a
     * different carrier logo. Be careful with this as this is rarely used and
     * an easy place for regression.
     */
    return option.carrier_logo || option.shipping_method;
  });

  return <LogoDeck shippingMethods={carrierLogos} selectedOption={selectedOption} />;
};
